import { Box, Button, Typography } from "@mui/material";
import { translate } from "../../../../translate/translate";
import FileOpenIcon from '@mui/icons-material/FileOpen';
import {ReactComponent as SapIcon} from "../../../../../assets/images/ic-sap.svg";
import { useNavigate } from "react-router-dom";

const ImportDataPageComponent = () => {
  const navigate = useNavigate();

  const handleFileImportClick = () => {
    navigate("/general/import-spreadsheets");
  };

  const handleSapImportClick = () => {
    navigate("/general/import-sap");
  };


  return (
    <>
      <section>
        <div className="floating-title" style={{ display: "flex", alignItems: "center" }}>
          <Typography variant="h5">{translate.t("import_data")}</Typography>
        </div>

        <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", marginBottom: "16px" }}>
            <Typography sx={{color: "#303F9F", fontSize: "16px"}}>{translate.t("select_source_data")}</Typography>
            <Box sx={{ display: "flex", flexDirection: "row", gap: "20px", alignItems: "flex-start" }}>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", width: "auto" }}>
                    <Button
                        variant="outlined"
                        onClick={handleFileImportClick}
                        sx={{
                            backgroundColor: "#FFFFFF",
                            border: "2px solid #E0E0E0",
                            borderRadius: "12px",
                            padding: "20px",
                            width: "270px",
                            height: "198px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            "&:hover": {
                                backgroundColor: "#F8F9FA",
                                border: "2px solid #B0BEC5",
                                boxShadow: "0 4px 20px rgba(0,0,0,0.1)"
                            },
                            "&:active": {
                                transition: "all 0.15s cubic-bezier(0.4, 0, 0.2, 1)"
                            }
                        }}
                    >
                        <FileOpenIcon sx={{width: "90px", height: "90px", color: "#90A4AE"}}/>
                    </Button>
                    <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#546E7A", textAlign: "center" }}>
                        {translate.t("files_xls")}
                    </Typography>
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", width: "auto" }}>
                    <Button
                        variant="outlined"
                        onClick={handleSapImportClick}
                        sx={{
                            backgroundColor: "#FFFFFF",
                            border: "2px solid #E0E0E0",
                            borderRadius: "12px",
                            padding: "20px",
                            width: "270px",
                            height: "198px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            "&:hover": {
                                backgroundColor: "#F8F9FA",
                                border: "2px solid #B0BEC5",
                                boxShadow: "0 4px 20px rgba(0,0,0,0.1)"
                            },
                            "&:active": {
                                transition: "all 0.15s cubic-bezier(0.4, 0, 0.2, 1)"
                            }
                        }}
                    >
                        <SapIcon style={{width: "158px", height: "78px", color: "#3949AB"}}/>
                    </Button>
                    <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#546E7A", textAlign: "center" }}>
                        {translate.t("sap_data")}
                    </Typography>
                </Box>
            </Box>

        </Box>
      </section>
    </>
  );
};

export default ImportDataPageComponent;
